import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  Button, Table, TableHead, TableBody, TableRow, TableCell,
  DialogTitle, Box,
  Typography,
  TextField,
  FormControl,
  Select,
  MenuItem,
} from '@material-ui/core';
import {
  Search, Add, Refresh, NavigateNext,
} from '@material-ui/icons';
import {
  setAddressCondition,
  setAddressPopFlg,
  getAddressMulti,
  setGetAddressFlg,
  setArea,
  setSelectArea,
  setPrefList,
  setSelectPref,
  setAddressKeyword,
  setErrMsgAddressKeyword,
  setCheckAddressKeyword,
  searchAddress,
  setAddressResult,
  setAddressAddCondition,
  setErrMsgAddressPop,
  setAddressDisplayCondition,
} from '../../actions/TargetAction';
import {
  getAreaMaster,
  setSystemLodingFLg,
} from '../../actions/CommonAction';
import {
  GET_MASTER_FLG,
  ADD_LIMIT_COUNT,
} from '../../../common/const';
import styles from './PopStyles.module.css';
import validator from '../../../common/validator';
import { ERROR } from '../../../common/message';
import { getMessage } from '../../../common/util';

class TargetPopAreaComponent extends Component {
  async componentDidMount() {
    const {
      areaList,
      getAreaMasterAct,
      setAreaAct,
      getAddressMultiAct,
      setAddressAddConditionAct,
      setAddressDisplayConditionAct,
      addressPopFlg,
      addressCondition,
      getAddressFlg,
      setGetAddressFlgAct,
    } = this.props;
    if (!areaList) {
      // 地域が未設定の場合、マスタから取得
      const ret = await getAreaMasterAct();
      if (ret && ret.area_list) {
        setAreaAct(ret.area_list);
      }
    }

    if (addressPopFlg && getAddressFlg === GET_MASTER_FLG.ON) {
      const ret = await getAddressMultiAct(addressCondition);
      if (ret) {
        const newAddressAddCondition = [];
        ret.result_list.forEach((condition) => {
          const constAddress = {
            area: condition.area,
            prefectures: condition.prefectures,
            city_prefectures: condition.city_prefectures,
            city: condition.city,
            dispCondition: condition.condition,
          };
          newAddressAddCondition.push(constAddress);
        });

        setAddressAddConditionAct(newAddressAddCondition);
        setAddressDisplayConditionAct(newAddressAddCondition);
        // 所在地取得フラグ設定
        setGetAddressFlgAct(GET_MASTER_FLG.OFF);
      }
    }
  }

  /**
   *地域候補リスト選択値変更
   */
  onChangeAreaSelectBox = (code) => {
    const {
      setSystemLodingFLgAct,
      setSelectAreaAct,
      areaList,
      setPrefListAct,
      setSelectPrefAct,
    } = this.props;

    setSystemLodingFLgAct(true);
    setSelectAreaAct(code);

    let prefList = null;
    if (code) {
      // 地域が1件選択された場合、地域マスタから都道府県リストを取得
      for (let i = 0; i < areaList.length; i += 1) {
        const areaCode = areaList[i].area_code;
        if (areaCode === code) {
          prefList = areaList[i].prefectures_list;
          break;
        }
      }
    }
    // 都道府県候補リストを更新
    setPrefListAct(prefList);
    // 都道府県候補リストの選択内容を初期化
    setSelectPrefAct('');

    setSystemLodingFLgAct(false);
  };

  /**
   * 所在地条件POPUPをclose
   */
  closeAddressPop = () => {
    const { setAddressPopFlgAct } = this.props;
    setAddressPopFlgAct(false);
  };

  /**
   * 所在地条件を削除
   */
  deleteCondition = (index) => {
    const {
      addressAddCondition,
      setAddressAddConditionAct,
      setErrMsgAddressPopAct,
    } = this.props;

    // エラーメッセージ初期化
    setErrMsgAddressPopAct();

    const items = addressAddCondition.filter((_, i) => (index !== i));
    setAddressAddConditionAct(items);
  }

  /**
   * 所在地キーワード 最大桁数のチェック
   */
  onBlurKeyword = () => {
    const {
      addressKeyword,
      setCheckAddressKeywordAct,
      setErrMsgAddressKeywordAct,
    } = this.props;

    // 入力チェック
    const msgs = [];
    validator.checkMaxLength(addressKeyword, 25, msgs);

    if (msgs.length !== 0) {
      // エラー有りの場合
      // エラーメッセージ、エラーフラグを設定
      setErrMsgAddressKeywordAct(getMessage(ERROR.E08009, msgs.join(',')));
      setCheckAddressKeywordAct(true);
      return;
    }

    // エラー無しの場合
    // エラーメッセージ、エラーフラグを解除
    setErrMsgAddressKeywordAct();
    setCheckAddressKeywordAct(false);
  }

  /**
   * 検索ボタン押下
   */
  searchAddress = async () => {
    const {
      selectArea,
      selectPref,
      addressKeyword,
      searchAddressAct,
      setAddressResultAct,
      setErrMsgAddressPopAct,
      setSystemLodingFLgAct,
    } = this.props;

    // エラーメッセージを初期化
    setErrMsgAddressPopAct();

    setSystemLodingFLgAct(true);

    // 所在地を取得
    const result = await searchAddressAct(selectArea, selectPref, addressKeyword);

    // 結果をセット
    setAddressResultAct(result);
    setSystemLodingFLgAct(false);
  }

  /**
   * 条件クリアボタン押下
   */
  clear = () => {
    const {
      setSelectAreaAct,
      setSelectPrefAct,
      setAddressKeywordAct,
      setPrefListAct,
      setAddressResultAct,
      setErrMsgAddressPopAct,
      setErrMsgAddressKeywordAct,
      setCheckAddressKeywordAct,
    } = this.props;

    // 検索条件を初期化
    setSelectAreaAct('');
    setSelectPrefAct('');
    setAddressKeywordAct();
    setPrefListAct(null);
    setAddressResultAct();

    // キーワード桁数チェック
    // エラーメッセージ、エラーフラグを解除
    setErrMsgAddressPopAct();
    setErrMsgAddressKeywordAct();
    setCheckAddressKeywordAct(false);
  }

  /**
   * 追加ボタン押下
   */
  addCondition = (index) => {
    const {
      addressResult,
      addressAddCondition,
      setAddressAddConditionAct,
      setErrMsgAddressPopAct,
    } = this.props;

    const addAddress = addressResult.address_list[index];

    let addConditionItem;
    if (!addAddress.prefectures_name) {
      addConditionItem = {
        area: addAddress.area_code,
        prefectures: addAddress.prefectures_code,
        city_prefectures: addAddress.city_prefectures,
        city: addAddress.city_code,
        dispCondition: `${addAddress.area_name}`,
      };
    } else if (!addAddress.city_name) {
      addConditionItem = {
        area: addAddress.area_code,
        prefectures: addAddress.prefectures_code,
        city_prefectures: addAddress.city_prefectures,
        city: addAddress.city_code,
        dispCondition: `${addAddress.area_name}：${addAddress.prefectures_name}`,
      };
    } else {
      addConditionItem = {
        area: addAddress.area_code,
        prefectures: addAddress.prefectures_code,
        city_prefectures: addAddress.city_prefectures,
        city: addAddress.city_code,
        dispCondition: `${addAddress.area_name}：${addAddress.prefectures_name}：${addAddress.city_name}`,
      };
    }

    if (addressAddCondition) {
      // 選択内容に値が設定されている場合

      // 選択内容リスト
      const newAddressAddCondition = [];
      addressAddCondition.forEach((item) => newAddressAddCondition.push(item));

      if (!newAddressAddCondition.some((item) => (
        item.area === addConditionItem.area
        && item.prefectures === addConditionItem.prefectures
        && item.city_prefectures === addConditionItem.city_prefectures
        && item.city === addConditionItem.city))) {
        if (newAddressAddCondition.length === ADD_LIMIT_COUNT.AREA) {
          setErrMsgAddressPopAct(getMessage(ERROR.E02005));
        } else {
          newAddressAddCondition.push(addConditionItem);
          // エラーメッセージを初期化
          setErrMsgAddressPopAct();
        }
      } else {
        // 重複している場合、エラーメッセージを表示
        // エラーメッセージを設定
        setErrMsgAddressPopAct(getMessage(ERROR.E02004));
      }
      setAddressAddConditionAct(newAddressAddCondition);
    } else {
      // 選択内容に値が設定されていない場合
      setErrMsgAddressPopAct();
      setAddressAddConditionAct([addConditionItem]);
    }
  }

  /**
   * 全て選択ボタン押下
   */
  addAllCondition = () => {
    const {
      addressResult,
      addressAddCondition,
      setAddressAddConditionAct,
      setErrMsgAddressPopAct,
    } = this.props;

    // 検索結果がnullかつ空では無い場合
    if (addressResult && Object.keys(addressResult).length !== 0) {
      const addConditionList = [];
      let addConditionItem;
      addressResult.address_list.forEach((item) => {
        if (!item.prefectures_name) {
          addConditionItem = {
            area: item.area_code,
            prefectures: item.prefectures_code,
            city_prefectures: item.city_prefectures,
            city: item.city_code,
            dispCondition: `${item.area_name}`,
          };
        } else if (!item.city_name) {
          addConditionItem = {
            area: item.area_code,
            prefectures: item.prefectures_code,
            city_prefectures: item.city_prefectures,
            city: item.city_code,
            dispCondition: `${item.area_name}：${item.prefectures_name}`,
          };
        } else {
          addConditionItem = {
            area: item.area_code,
            prefectures: item.prefectures_code,
            city_prefectures: item.city_prefectures,
            city: item.city_code,
            dispCondition: `${item.area_name}：${item.prefectures_name}${item.city_name}`,
          };
        }
        addConditionList.push(addConditionItem);
      });

      if (addressAddCondition) {
        // 選択内容に値が設定されている場合

        // 選択内容リスト
        const newAddressAddCondition = [];
        addressAddCondition.forEach((item) => newAddressAddCondition.push(item));

        // 重複チェック
        let hasDuplicate = false;

        addConditionList.forEach((addItem) => {
          // 追加条件リストの内容をチェックして、重複しないものだけ選択内容リストに追加
          if (!newAddressAddCondition.some((selectItem) => (
            selectItem.area === addItem.area
            && selectItem.prefectures === addItem.prefectures
            && selectItem.city_prefectures === addItem.city_prefectures
            && selectItem.city === addItem.city))) {
            newAddressAddCondition.push(addItem);
          } else {
            // 重複データが存在する場合
            hasDuplicate = true;
          }
        });

        if (newAddressAddCondition.length > ADD_LIMIT_COUNT.AREA) {
          setErrMsgAddressPopAct(getMessage(ERROR.E02005));
        } else {
          if (hasDuplicate) {
            // 重複データが存在する場合
            // エラーメッセージを設定
            setErrMsgAddressPopAct(getMessage(ERROR.E02004));
          } else {
            // 重複データが存在しない場合
            // エラーメッセージを初期化
            setErrMsgAddressPopAct();
          }

          setAddressAddConditionAct(newAddressAddCondition);
        }
      } else if (addConditionList.length > ADD_LIMIT_COUNT.AREA) {
        setErrMsgAddressPopAct(getMessage(ERROR.E02005));
      } else {
        // 選択内容に値が設定されていない場合
        // エラーメッセージを初期化
        setErrMsgAddressPopAct();
        setAddressAddConditionAct(addConditionList);
      }
    }
  }

  /**
   * キャンセルボタン押下
   */
  cancel = async () => {
    const {
      setSelectAreaAct,
      setSelectPrefAct,
      setPrefListAct,
      setAddressKeywordAct,
      setAddressResultAct,
      setErrMsgAddressPopAct,
      setErrMsgAddressKeywordAct,
      setCheckAddressKeywordAct,
    } = this.props;

    // 検索条件、検索結果、エラーメッセージ初期化
    setSelectAreaAct('');
    setSelectPrefAct('');
    setAddressKeywordAct();
    setPrefListAct(null);
    setAddressResultAct();
    setErrMsgAddressPopAct();
    setErrMsgAddressKeywordAct();
    setCheckAddressKeywordAct(false);

    // ポップアップを閉じる
    this.closeAddressPop();
  }

  /**
   * 設定ボタン押下
   */
  setCondition = () => {
    const {
      addressAddCondition,
      setSelectAreaAct,
      setSelectPrefAct,
      setPrefListAct,
      setAddressKeywordAct,
      setAddressResultAct,
      setErrMsgAddressPopAct,
      setErrMsgAddressKeywordAct,
      setCheckAddressKeywordAct,
      setAddressConditionAct,
      setAddressDisplayConditionAct,
    } = this.props;

    // 選択内容一覧がnullではない場合
    if (addressAddCondition) {
      const newAddressCondition = [];
      addressAddCondition.forEach((condition) => {
        const address = {
          area: condition.area,
          prefectures: condition.prefectures,
          city_prefectures: condition.city_prefectures,
          city: condition.city,
        };
        newAddressCondition.push(address);
      });

      setAddressConditionAct(newAddressCondition);
      setAddressDisplayConditionAct(addressAddCondition);
    }

    // 検索条件、検索結果、エラーメッセージ初期化
    setSelectAreaAct('');
    setSelectPrefAct('');
    setAddressKeywordAct();
    setPrefListAct(null);
    setAddressResultAct();
    setErrMsgAddressPopAct();
    setErrMsgAddressKeywordAct();
    setCheckAddressKeywordAct(false);

    // ポップアップを閉じる
    this.closeAddressPop();
  }

  render() {
    const {
      addressPopFlg,
      areaList,
      prefList,
      selectArea,
      selectPref,
      setSelectPrefAct,
      addressKeyword,
      setAddressKeywordAct,
      checkErrFlg,
      errMsgAddressKeyword,
      addressResult,
      errMsgAddressPop,
      addressAddCondition,
    } = this.props;

    return (addressPopFlg && (
      <Box className={`${styles.dialog}`}>
        <Box className={`${styles.contents}`}>
          <Box className={`${styles.marginBottomHalf}`}>
            <DialogTitle>所在地選択</DialogTitle>
          </Box>
          <Box className={`${styles.height2}`}>
            <span className={`${styles.errorMsg}`}>{errMsgAddressPop}</span>
          </Box>
          <Box className={`${styles.searchconditionareaIndustry}`}>
            <Box className={`${styles.condition}  ${styles.industrySelect}`}>
              <Box className={`${styles.conditionTitle}`}>地域</Box>
              <Box className={`${styles.conditionValue}`}>
                <FormControl variant="outlined">
                  <Select
                    value={selectArea}
                    onChange={(ev) => this.onChangeAreaSelectBox(ev.target.value)}
                    MenuProps={{
                      getContentAnchorEl: null,
                      anchorOrigin: { vertical: 30, horizontal: 0 },
                      PaperProps: {
                        className: styles.selectStyle,
                      },
                    }}
                  >
                    <MenuItem key="" value="">　</MenuItem>
                    {areaList
                      && areaList.map((area) => (
                        <MenuItem
                          key={area.area_code}
                          value={area.area_code || ''}
                        >
                          {area.area_name}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
              </Box>
              <Box className={`${styles.conditionTitle}`}>都道府県</Box>
              <Box className={`${styles.conditionValue}`}>
                <FormControl variant="outlined">
                  <Select
                    value={selectPref}
                    onChange={(ev) => setSelectPrefAct(ev.target.value)}
                    MenuProps={{
                      getContentAnchorEl: null,
                      anchorOrigin: { vertical: 30, horizontal: 0 },
                      PaperProps: {
                        className: styles.selectStyle,
                      },
                    }}
                  >
                    <MenuItem key="" value="">　</MenuItem>
                    {prefList
                      && prefList.map((pref) => (
                        <MenuItem
                          key={pref.prefectures_code}
                          value={pref.prefectures_code}
                        >
                          {pref.prefectures_name}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
              </Box>
            </Box>
            <Box className={`${styles.condition}`}>
              <Box className={`${styles.conditionTitle}`}>キーワード</Box>
              <Box className={`${styles.conditionValue}`}>
                <TextField
                  InputProps={{ classes: { input: styles.inputSizing } }}
                  value={addressKeyword || ''}
                  onChange={(ev) => setAddressKeywordAct(ev.target.value)}
                  onBlur={this.onBlurKeyword}
                  variant="outlined"
                  error={checkErrFlg.checkAddressKeyword}
                />
                {checkErrFlg.checkAddressKeyword
                  && (
                    <Box className={`${styles.baloon}`}>
                      <Box className={`${styles.triangle}`}>
                        <Box className={`${styles.triangleDiv}`} />
                      </Box>
                      <Box className={`${styles.babble}`}>
                        {errMsgAddressKeyword}
                      </Box>
                    </Box>
                  )}
              </Box>
              <Box className={`${styles.conditionButton}`}>
                <Button
                  variant="contained"
                  color="primary"
                  startIcon={<Refresh />}
                  onClick={() => this.clear()}
                  className={`${styles.height2}`}
                >
                  条件クリア
                </Button>
              </Box>
              <Box className={`${styles.conditionButton}`}>
                <Button
                  variant="contained"
                  color="secondary"
                  startIcon={<Search />}
                  onClick={this.searchAddress}
                  disabled={checkErrFlg.checkIndustryKeyword}
                  className={`${styles.height2}`}
                >
                  検索
                </Button>
              </Box>
            </Box>
          </Box>
          <Box className={`${styles.searchResultarea}`}>
            <Box className={`${styles.searchResultareaTableHead}`}>
              <Table className={`${styles.tableLayoutFixed}`}>
                <TableHead>
                  <TableRow>
                    <TableCell className={`${styles.dialogTableHeader} ${styles.dialogTableCell} ${styles.searchResultareaHeader} ${styles.addDeleteCell}`}> </TableCell>
                    <TableCell className={`${styles.dialogTableHeader} ${styles.dialogTableCell} ${styles.searchResultareaHeader}`}>地域</TableCell>
                    <TableCell className={`${styles.dialogTableHeader} ${styles.dialogTableCell} ${styles.searchResultareaHeader}`}>都道府県</TableCell>
                    <TableCell className={`${styles.dialogTableHeader} ${styles.dialogTableCell} ${styles.searchResultareaHeader}`}>市区町村</TableCell>
                  </TableRow>
                </TableHead>
              </Table>
            </Box>
            <Box className={`${styles.searchResultareaTableBody}`}>
              <Table className={`${styles.tableLayoutFixed}`}>
                <TableBody>
                  {addressResult
                    && addressResult.address_list
                    && addressResult.address_list.map((result, i) => (
                      <TableRow key={i}>
                        <TableCell className={`${styles.dialogTableCell} ${styles.addDeleteCell}`}>
                          <Button
                            variant="contained"
                            className={`${styles.tooltip} addDelete`}
                            onClick={() => this.addCondition(i)}
                          >
                            <span>＋</span>
                            <Box className={`${styles.description}`}>検索条件に追加</Box>
                          </Button>
                        </TableCell>
                        <TableCell className={`${styles.dialogTableCell}`}>{result.area_name}</TableCell>
                        <TableCell className={`${styles.dialogTableCell}`}>{result.prefectures_name}</TableCell>
                        <TableCell className={`${styles.dialogTableCell}`}>{result.city_name}</TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </Box>
          </Box>
          <Box className={`${styles.listSpacerArea}`}>
            <Box className={`${styles.addAllArea}`}>
              <Button
                variant="contained"
                onClick={() => this.addAllCondition()}
                startIcon={<Add />}
                className={`${styles.displayFlex} ${styles.height2} addAll`}
              >
                全て選択
              </Button>
            </Box>
            <Box className={`${styles.arrowDown}`}>
              <Typography className={`${styles.fontSize}`}>≫</Typography>
            </Box>
          </Box>
          <Box className={`${styles.productsCondition}`}>
            <Box className={`${styles.productsconditionTableHead}`}>
              <Table className={`${styles.tableLayoutFixed}`}>
                <TableHead>
                  <TableRow>
                    <TableCell className={`${styles.dialogTableHeader} ${styles.dialogTableCell} ${styles.conditionlistHeader} ${styles.addDeleteCell}`}> </TableCell>
                    <TableCell className={`${styles.dialogTableHeader} ${styles.dialogTableCell} ${styles.conditionlistHeader}`}>選択内容</TableCell>
                  </TableRow>
                </TableHead>
              </Table>
            </Box>
            <Box className={`${styles.productsconditionTableBody}`}>
              <Table className={`${styles.tableLayoutFixed}`}>
                <TableBody>
                  {addressAddCondition
                    && addressAddCondition.map((selectCondition, i) => (
                      <TableRow key={i}>
                        <TableCell className={`${styles.dialogTableCell} ${styles.addDeleteCell}`}>
                          <Button
                            variant="contained"
                            className={`${styles.tooltip} addDelete`}
                            onClick={() => this.deleteCondition(i)}
                          >
                            <span>－</span>
                            <Box className={`${styles.description}`}>検索条件から削除</Box>
                          </Button>
                        </TableCell>
                        <TableCell className={`${styles.dialogTableCell}`}>{selectCondition.dispCondition}</TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </Box>
          </Box>
          <Box className={`${styles.buttonArea}`}>
            <Button
              variant="contained"
              onClick={() => this.cancel()}
              className={`${styles.height2} cancel`}
            >
              キャンセル
            </Button>
            <Button
              variant="contained"
              color="secondary"
              className={`${styles.marginLeft1} ${styles.height2}`}
              onClick={() => this.setCondition()}
            >
              <NavigateNext className={`${styles.setButtonIcon}`} />
              設定
            </Button>
          </Box>

        </Box>
      </Box>
    ));
  }
}

export default connect(
  (state) => ({
    addressCondition: state.target.addressCondition,
    addressPopFlg: state.target.addressPopFlg,
    getAddressFlg: state.target.getAddressFlg,
    areaList: state.target.areaList,
    selectArea: state.target.selectArea,
    prefList: state.target.prefList,
    selectPref: state.target.selectPref,
    addressKeyword: state.target.addressKeyword,
    checkErrFlg: state.target.checkErrFlg,
    errMsgAddressKeyword: state.target.errMsgAddressKeyword,
    addressResult: state.target.addressResult,
    addressAddCondition: state.target.addressAddCondition,
    errMsgAddressPop: state.target.errMsgAddressPop,
  }),
  (dispatch) => ({
    setAddressConditionAct: (obj) => dispatch(setAddressCondition(obj)),
    setAddressPopFlgAct: (bool) => dispatch(setAddressPopFlg(bool)),
    getAddressMultiAct: (obj) => dispatch(getAddressMulti(obj)),
    setGetAddressFlgAct: (object) => dispatch(setGetAddressFlg(object)),
    getAreaMasterAct: () => dispatch(getAreaMaster()),
    setAreaAct: (obj) => dispatch(setArea(obj)),
    setSelectAreaAct: (str) => dispatch(setSelectArea(str)),
    setPrefListAct: (obj) => dispatch(setPrefList(obj)),
    setSelectPrefAct: (str) => dispatch(setSelectPref(str)),
    setAddressKeywordAct: (str) => dispatch(setAddressKeyword(str)),
    setErrMsgAddressKeywordAct: (str) => dispatch(setErrMsgAddressKeyword(str)),
    setCheckAddressKeywordAct: (bool) => dispatch(setCheckAddressKeyword(bool)),
    searchAddressAct: (
      selectArea, selectPref, addressKeyword,
    ) => dispatch(searchAddress(
      selectArea, selectPref, addressKeyword,
    )),
    setAddressResultAct: (obj) => dispatch(setAddressResult(obj)),
    setAddressAddConditionAct: (obj) => dispatch(setAddressAddCondition(obj)),
    setErrMsgAddressPopAct: (str) => dispatch(setErrMsgAddressPop(str)),
    setAddressDisplayConditionAct: (obj) => dispatch(setAddressDisplayCondition(obj)),
    setSystemLodingFLgAct: (bool) => dispatch(setSystemLodingFLg(bool)),

  }),
)(TargetPopAreaComponent);
